import { render, staticRenderFns } from "./stopTable.vue?vue&type=template&id=0f19a7f3"
import script from "./stopTable.vue?vue&type=script&lang=js"
export * from "./stopTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports